/**
 * OneID qaytish nuqtasi: provayder qaytargan `code` va `state` backendga
 * uzatiladi, backend tokenlarni cookie'ga qo'yadi va profilni qaytaradi.
 */
import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { useAuth } from "@/app/AuthContext";
import { ApiError } from "@/shared/api/client";
import { authApi } from "@/shared/api/endpoints";
import { useI18n } from "@/shared/i18n";
import { BrandMark, Icon } from "@/shared/ui/Icon";

export function OneIdCallbackPage() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [params] = useSearchParams();
  const [error, setError] = useState("");

  useEffect(() => {
    const code = params.get("code");
    const state = params.get("state") ?? "";
    if (!code) {
      setError("OneID «code» parametrini qaytarmadi.");
      return;
    }

    let cancelled = false;
    authApi
      .oneidCallback(code, state)
      .then((result) => {
        if (cancelled) return;
        setSession(result.user);
        navigate(result.next || "/kabinet", { replace: true });
      })
      .catch((caught: unknown) => {
        if (cancelled) return;
        setError(
          caught instanceof ApiError && !caught.isOffline ? caught.message : t("auth.err.network"),
        );
      });

    return () => {
      cancelled = true;
    };
  }, [params, navigate, setSession, t]);

  return (
    <div
      className="auth-panel"
      style={{ minHeight: "100vh", alignItems: "center", justifyContent: "center" }}
    >
      <div className="auth-form-wrap" style={{ textAlign: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
          <BrandMark size={48} />
        </div>
        {error ? (
          <>
            <div className="alert alert-error" role="alert">
              <Icon name="alert" size={18} />
              <span>{error}</span>
            </div>
            <Link className="btn btn-outline btn-block" to="/kirish" style={{ marginTop: 16 }}>
              {t("action.retry")}
            </Link>
          </>
        ) : (
          <p className="muted">{t("state.loading")}</p>
        )}
      </div>
    </div>
  );
}

/**
 * Mobil ilova qaytish manzili. Odatda ilova bu URL'ni WebView'da ushlab,
 * `code`/`state`ni o'zi `/auth/oneid/mobile/callback/` API'ga yuboradi —
 * sahifa faqat havola oddiy brauzerda ochilib qolganda ko'rinadi.
 */
export function OneIdMobileCallbackPage() {
  return (
    <div
      className="auth-panel"
      style={{ minHeight: "100vh", alignItems: "center", justifyContent: "center" }}
    >
      <div className="auth-form-wrap" style={{ textAlign: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
          <BrandMark size={48} />
        </div>
        <p className="alert alert-info" role="status">
          <Icon name="info" size={18} />
          <span>OneID orqali tasdiqlandi. Kirishni yakunlash uchun mobil ilovaga qayting.</span>
        </p>
      </div>
    </div>
  );
}
